export default __webpack_public_path__ + "media/images/landing-31-550x420-419c2006953a8b86413c007990368e78.jpg";